var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTable = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 3h2.5v2.5H3V3zm7.5 0H13v2.5h-2.5V3zM9.25 3h-2.5v2.5h2.5V3zM3 6.75h2.5v2.5H3v-2.5zm10 0h-2.5v2.5H13v-2.5zm-6.25 0h2.5v2.5h-2.5v-2.5zM5.5 10.5H3V13h2.5v-2.5zm5 0H13V13h-2.5v-2.5zm-1.25 0h-2.5V13h2.5v-2.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTable);
export default ForwardRef;